<template>
  <a-select
            show-search
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @change="handleMatrialChange($event)"
            @inputKeydown="handleMatrialSearch($event)"
            @focus="handleMatrialFocus"
            :options="materialOptions"
            :value="getValueSting"
  ></a-select>
</template>

<script>
  import {getAction} from '@api/manage'

  export default {
    name: "MaterialSearch",
    mixins: [],
    components: {},
    data() {
      return {
        materialOptions: [],
        url: {
          queryMaterialByCodeOrName: "/bas/basMaterial/queryByCodeOrName",
        },
      };
    },
    props:{
      value: [String, Number],
    },
    created() {
      this.initMaterialOptions()
    },
    computed: {
      getValueSting(){
        return this.value != null ? this.value.toString() : null;
      },
    },
    methods:{
      handleMatrialChange(e){
        let val;
        val = e
        // this.$emit('change', val);
        this.$emit('input', val);
      },
      initMaterialOptions(){
        const that = this
        getAction(this.url.queryMaterialByCodeOrName,{target:''}).then(res=>{
          if(res.success){
            that.materialOptions = []
            res.result.forEach((item)=>{
              that.materialOptions.push({value:item.id,label:item.name+'('+item.code+')'})
            })
          }
        })
      },
      handleMatrialFocus(){
        this.materialOptions = []
      },
      handleMatrialSearch(event){
        let that = this
        if(event.key=='Enter'){
          getAction(this.url.queryMaterialByCodeOrName,{target:event.target.value}).then(res=>{
            if(res.success){
              that.materialOptions = []
              res.result.forEach((item)=>{
                that.materialOptions.push({value:item.id,label:item.name+'('+item.code+')'})
              })
            }
          })
        }
      },
    }
  }
</script>